import { render, staticRenderFns } from "./GarmentAdmin.vue?vue&type=template&id=a8761b78"
import script from "./GarmentAdmin.vue?vue&type=script&lang=js"
export * from "./GarmentAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports